var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.722C0 3.47.51 2.268 1.42 1.384A4.914 4.914 0 0 1 4.848 0h16.158c1.286 0 2.518.498 3.428 1.384a4.665 4.665 0 0 1 1.42 3.338v9.444a4.662 4.662 0 0 1-1.42 3.338 4.914 4.914 0 0 1-3.428 1.384h-5.794l-5.988 5.836a1.656 1.656 0 0 1-1.762.342 1.608 1.608 0 0 1-.726-.58 1.546 1.546 0 0 1-.274-.874V18.89H4.846a4.914 4.914 0 0 1-3.428-1.384A4.662 4.662 0 0 1 0 14.166V4.722Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M32 10.886v9.444c0 1.574-.97 4.722-4.848 4.722h-1.616v4.722c0 .524-.324 1.574-1.616 1.574a1.722 1.722 0 0 1-.808-.178l-6.282-6.118h-5.838l4.848-4.724h4.848c2.154 0 6.464-1.258 6.464-6.294v-7.87c1.616 0 4.848.944 4.848 4.722Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagings);
export default __webpack_public_path__ + "static/media/messagings.d71739c3.svg";
export { ForwardRef as ReactComponent };